module.exports = __webpack_public_path__ + "static/img/icon-book.97b88584.svg";